import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import {
		Box,
		Button,
		Card,
		CardContent,
		CardHeader,
		Divider,
		Grid,
		TextField
} from '@material-ui/core';
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import ParkingZoneGroupRepository from "../../../repositories/ParkingZoneGroupRepository";
import {useNavigate, useParams} from "react-router";
import FormLoading from "../../../components/FormLoading";
import {useCrudForm} from "../../../hooks/crud/Form";
import {useTranslation} from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const Form = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

	const {id} = useParams();
	const repository = new ParkingZoneGroupRepository();
	const [parkingZones, setParkingZones] = useState([]);
	const [selectedParkingZones, setSelectedParkingZones] = useState([]);
	const { form, onSubmit, isSubmitting, hasError, errorMessage } = useCrudForm(repository, {
            id: id,
            onSuccess: () => navigate("/app/parking-zone-groups"),
            onLoad: (data) => {
                if (data) {
                    try {
                        updateParkingZones(data.ParkingZones);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        }
        );

	const { control, register, setValue, unregister, getValues } = form;

    useEffect(() => {

        register('ParkingZones', { });

        return () => {
            unregister('ParkingZones');
        }
    }, []);

    useEffect(async () => {

        const parkingZoneRepository = new ParkingZoneRepository();

        const result2 = await parkingZoneRepository.getSelector();
        setParkingZones(result2.data);
    }, [id]);

    const parkingZoneSelectHandler = ({target}) => {
        updateParkingZones(target.value);
    }

    const updateParkingZones = (value) => {

        setSelectedParkingZones(value);
        setValue('ParkingZones', value);
    }

    return (
			<form onSubmit={onSubmit}
			>
                 <Grid item xs={12} lg={8}>
                     {isSubmitting && <FormLoading />}
                     <Card>
                        <CardHeader title={t('Information')} />
                        <Divider />
                        <CardContent>

                             <Box>
                                <Controller
                                     as={TextField} control={control}
                                     error={hasError('Name')}
                                     fullWidth
                                     helperText={errorMessage('Name')}
                                     label={t('Name')}
                                     type={"text"}
                                     name="Name"
                                     defaultValue={""}
                                     variant="outlined"
                                     rules={{ required: true }}
                                />
                             </Box>
                            <Box mt={3}>
                                <Controller
                                        name="IsActive"
                                        control={control}
                                        defaultValue={false}
                                        render={({ value, onChange, checked }) => (
                                                    <FormControlLabel control={(
                                                          <Switch
                                                            checked={value}
                                                            value={value}
                                                            onChange={(event, value) => onChange(value)}
                                                          />)} label={t('Active')} />
                                                        )}
                                      />
                            </Box>
                        </CardContent>
                     </Card>
                     <Box mt={3}>
                         <Card>
                             <CardHeader title={t('Parking zones')} />
                             <Divider />
                             <CardContent>
                                <Select
                                      multiple
                                      fullWidth
                                      displayEmpty
                                      value={selectedParkingZones}
                                      input={<Input />}
                                      renderValue={(selected) => {
                                        return parkingZones.filter(x => selected.includes(x.Id)).map(x => x.Name).join(', ');
                                      }}
                                      MenuProps={MenuProps}
                                      onChange={parkingZoneSelectHandler}
                                    >
                                      {parkingZones.map((item) => (
                                        <MenuItem key={item.Id} value={item.Id}>
                                            <Checkbox checked={selectedParkingZones.filter(x => x == item.Id).length > 0} />
                                            <ListItemText primary={item.Name} />
                                        </MenuItem>
                                      ))}
                                    </Select>

                             </CardContent>
                         </Card>
                     </Box>`
                     </Grid>
                     <Box mt={2}>

                         <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            name="submit"
                            disabled={isSubmitting}
                        >
                            {t('Save')}
                        </Button>
                     </Box>
                </form>
	);
};

export default Form;